export default __webpack_public_path__ + "static/media/SEC2090.34I-43636_-26071_0.f957d077.jpg";